import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { purchaseAPI } from '../api';

export default function VerifyPage() {
  const { code } = useParams();
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    purchaseAPI.verify(code).then(r => setResult(r.data)).catch(() => setResult({ valid: false, error: 'Ticket not found' })).finally(() => setLoading(false));
  }, [code]);

  if (loading) return <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', fontSize: 18 }}>Verifying ticket...</div>;

  const { valid, purchase } = result;

  return (
    <div style={{ minHeight: '100vh', background: valid ? '#f0fdf4' : '#fef2f2', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24 }}>
      <div style={{ background: '#fff', borderRadius: 20, maxWidth: 440, width: '100%', padding: 32, textAlign: 'center', boxShadow: '0 8px 40px rgba(0,0,0,0.1)' }}>
        <div style={{ fontSize: 64, marginBottom: 16 }}>{valid ? '✅' : '❌'}</div>
        <h2 style={{ color: valid ? '#166534' : '#991B1B', margin: '0 0 8px' }}>{valid ? 'Valid Ticket' : 'Invalid Ticket'}</h2>
        {valid && purchase ? (
          <div style={{ textAlign: 'left', background: '#f9fafb', borderRadius: 10, padding: 20, marginTop: 20 }}>
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              {[
                ['Event', purchase.event_name],
                ['Date', new Date(purchase.date).toLocaleDateString('en-KE', { dateStyle: 'long' })],
                ['Ticket Holder', purchase.buyer_name],
                ['Ticket Type', purchase.ticket_type_name],
                ['Quantity', purchase.quantity],
                purchase.member_number ? ['Member #', purchase.member_number] : null,
              ].filter(Boolean).map(([label, value]) => (
                <tr key={label}>
                  <td style={{ padding: '6px 0', color: '#6B7280', fontSize: 13 }}>{label}</td>
                  <td style={{ padding: '6px 0', fontWeight: 600, textAlign: 'right', fontSize: 13 }}>{value}</td>
                </tr>
              ))}
            </table>
          </div>
        ) : (
          <p style={{ color: '#991B1B' }}>{result.error}</p>
        )}
        <div style={{ marginTop: 20, fontSize: 12, color: '#9CA3AF' }}>Ticket Code: {code}</div>
      </div>
    </div>
  );
}
